export default "__VITE_ASSET__81f336d5__"